import React, { useEffect, useState } from "react";
import { Label, RequiredRule, SimpleItem } from 'devextreme-react/form';
import { Button, CheckBox, DateBox, NumberBox, TextBox } from "devextreme-react";
import LVButtonAccion from "../../../Basicos/LVButtonAccion";
import { FormateoFechaPara_yyyyMMdd } from "neftis7_apicaller/src/funciones/Varios";
import { LVForm } from "../../../Basicos/LVForm";
import { function_ABM_EEX_Clientes_Leer, function_ABM_EEX_Clientes_ModificarBasico } from "neftis7_apicaller/src/funciones/ABM/EEX/ABM_EEX_Clientes";
import LVSelectorClientes from "../../../Selectores/LVSelectorClientes";
import ComboAbmEexClientesLocaciones from "../../Combos/ComboAbmEexClientesLocaciones";

const LV_EEX_Clientes = ({ IdCliente, onPuedeGuardarChange, setIdParticipante, modo = "VistaPersona" }) => {

  const { ABM_EEX_Clientes: { function_ABM_EEX_Clientes_LeerPorDNISinPassword, function_ABM_EEX_Clientes_InsertarBasico } } = require('neftis7_apicaller');
  const [idCliente, setIdCliente] = useState(IdCliente);
  const [cuit, setCUIT] = useState("");
  const [nombre, setNombre] = useState("");
  const [apellido, setApellido] = useState("");
  const [razonSocial, setRazonSocial] = useState("");
  const [telefono, setTelefono] = useState("");
  const [eMail, setEMail] = useState("");
  const [fechaNacimiento, setFechaNacimiento] = useState(new Date());
  const [calle, setCalle] = useState("");
  const [numero, setNumero] = useState("");
  const [piso, setPiso] = useState("");
  const [depto, setDepto] = useState("");
  const [codigoPostal, setCodigoPostal] = useState("");
  const [codigoLocacion, setCodigoLocacion] = useState("");
  const [locaciones, setLocaciones] = useState([]);
  const [mostrarSelectorLocacion, setMostrarSelectorLocacion] = useState(false);
  const [password, setPassword] = useState("");
  const [puedeGuardar, setPuedeGuardar] = useState(true);
  const [esMenor, setEsMenor] = useState(true);
  const [modoDelControl, setModoDelControl] = useState(modo);
  const [showPopupClientes, setShowPopupClientes] = useState(false);
  const [cierreEnProceso, setCierreEnProceso] = useState(false);

  const AccionesSegunCUIT = async () => {
    setMostrarSelectorLocacion(false)
    if (cuit && cuit !== "" && cuit != 0) {
      const resultClientes = await function_ABM_EEX_Clientes_LeerPorDNISinPassword(cuit)

      if (resultClientes && resultClientes.data && resultClientes.data.length > 0) {
        setIdCliente(resultClientes.data[0].IdCliente);
        setNombre(resultClientes.data[0].Nombre);
        setApellido(resultClientes.data[0].Apellido);
        const [year, month, day] = resultClientes.data[0].FechaNacimiento.split("-");
        const fechaExacta = new Date(parseInt(year), parseInt(month) - 1, parseInt(day));
        setFechaNacimiento(fechaExacta);
        setRazonSocial(resultClientes.data[0].RazonSocial)
        setPassword(resultClientes.data[0].Password)


        setLocaciones(resultClientes.data[0].Locaciones)

        if (resultClientes.data[0].Locaciones.length === 1) {
          setCodigoLocacion(resultClientes.data[0].Locaciones[0].CodigoLocacionCliente)
          setTelefono(resultClientes.data[0].Locaciones[0].TelefonoCelular);
          setEMail(resultClientes.data[0].Locaciones[0].Email);
          setCalle(resultClientes.data[0].Locaciones[0].Calle)
          setNumero(resultClientes.data[0].Locaciones[0].Numero)
          setPiso(resultClientes.data[0].Locaciones[0].Piso)
          setDepto(resultClientes.data[0].Locaciones[0].Depto)
          setCodigoPostal(resultClientes.data[0].Locaciones[0].CodigoPostal)
        } else {
          setMostrarSelectorLocacion(true);
          setCodigoLocacion(null);
        }

        setPuedeGuardar(false)
      }
      else {
        await VacioComponente()
      }
    } else {
      await VacioComponente();
    }
  }

  const AccionesSegunCodigo = async () => {
    setMostrarSelectorLocacion(false)
    if (IdCliente && IdCliente !== "" && IdCliente != 0) {
      const resultClientes = await function_ABM_EEX_Clientes_Leer(IdCliente)

      if (resultClientes && resultClientes.data) {
        setCUIT(resultClientes.data.CUIT.replace(/[-.]/g, '')); //SACO LOS - y .
        setNombre(resultClientes.data.Nombre);
        setApellido(resultClientes.data.Apellido);
        const [year, month, day] = resultClientes.data.FechaNacimiento.split("-");
        const fechaExacta = new Date(parseInt(year), parseInt(month) - 1, parseInt(day));
        setFechaNacimiento(fechaExacta);
        setRazonSocial(resultClientes.data.RazonSocial)
        setPassword(resultClientes.data[0].Password)

        setLocaciones(resultClientes.data[0].Locaciones)

        if (resultClientes.data[0].Locaciones.length === 1) {
          setCodigoLocacion(resultClientes.data[0].Locaciones[0].CodigoLocacionCliente)
          setTelefono(resultClientes.data[0].Locaciones[0].TelefonoCelular);
          setEMail(resultClientes.data[0].Locaciones[0].Email);
          setCalle(resultClientes.data[0].Locaciones[0].Calle)
          setNumero(resultClientes.data[0].Locaciones[0].Numero)
          setPiso(resultClientes.data[0].Locaciones[0].Piso)
          setDepto(resultClientes.data[0].Locaciones[0].Depto)
          setCodigoPostal(resultClientes.data[0].Locaciones[0].CodigoPostal)
        } else {
          setMostrarSelectorLocacion(true);
          setCodigoLocacion(null);
        }

        setPuedeGuardar(false)
      }
      else {
        await VacioComponente()
      }
    } else {
      await VacioComponente();
    }
  }

  const VacioComponente = async () => {
    setMostrarSelectorLocacion(false)
    setIdCliente(0);
    setNombre("");
    setApellido("");
    setTelefono("");
    setEMail("");
    setFechaNacimiento(new Date());
    setRazonSocial("");
    setCodigoLocacion("")
    setCalle("")
    setNumero("")
    setPiso("")
    setDepto("")
    setCodigoPostal("")
    setLocaciones([])

    setPuedeGuardar(true)
  }

  useEffect(() => {
    const Comp = localStorage.getItem("CodigoCompania");

    if (["AVT", "EME", "OTR", "MER"].includes(Comp)) {
      setModoDelControl("VistaEmpresa");
    } else {
      setModoDelControl("VistaPersona");
    }
  }, []);

  useEffect(() => {
    if (idCliente > 0 && setIdParticipante) {
      setIdParticipante(idCliente);
      if (cuit === "") {
        AccionesSegunCodigo(idCliente)
      }
    }
  }, [idCliente, setIdParticipante]);

  useEffect(() => {
    const acciones = async () => {
      try {
        await AccionesSegunCUIT()
      } catch (error) {
        alert(error);
      }
    }
    acciones();

  }, [cuit]);

  useEffect(() => {
    if (onPuedeGuardarChange) {
      onPuedeGuardarChange(puedeGuardar);
    }
  }, [puedeGuardar, onPuedeGuardarChange]);

  const handleIdClienteOnValueChanged = (e) => {
    setIdCliente(e.value)
  }

  const handleCuitOnValueChanged = (e) => {
    setCUIT(e.value)
  }

  const handleNombreOnValueChanged = (e) => {
    setNombre(e.value)
  }

  const handleApellidoOnValueChanged = (e) => {
    setApellido(e.value)
  }

  const handleRazonSocialOnValueChanged = (e) => {
    setRazonSocial(e.value)
  }

  const handleTelefonoOnValueChanged = (e) => {
    setTelefono(e.value)
  }

  const handleEMailOnValueChanged = (e) => {
    setEMail(e.value)
  }

  const handleFechaNacimientoOnValueChanged = (e) => {
    setFechaNacimiento(e.value)

    const fechaNacimiento = new Date(e.value);
    const hoy = new Date();
    let edad = hoy.getFullYear() - fechaNacimiento.getFullYear();
    const mes = hoy.getMonth() - fechaNacimiento.getMonth();
    const dia = hoy.getDate() - fechaNacimiento.getDate();

    if (mes < 0 || (mes === 0 && dia < 0)) {
      edad = edad - 1;
    }

    if (edad < 18) {
      setEsMenor(true)
    }
    else {
      setEsMenor(false)
    }
  }

  const handleCalleOnValueChanged = (e) => {
    setCalle(e.value)
  }

  const handleNumeroOnValueChanged = (e) => {
    setNumero(e.value)
  }

  const handlePisoOnValueChanged = (e) => {
    setPiso(e.value)
  }

  const handleDeptoOnValueChanged = (e) => {
    setDepto(e.value)
  }

  const handleCodigoPostalOnValueChanged = (e) => {
    setCodigoPostal(e.value)
  }

  const handleOnSelectedCodigoChange_Cliente = (codigo, razonSocial, cUIT) => {
    try {

      setIdCliente(0);
      setCUIT("");

      setCUIT(cUIT);
      setShowPopupClientes(false)
    } catch (error) {
      alert(error)
    }
  };

  const onClickBuscarCliente = async () => {
    setShowPopupClientes(true)
  };

  const onClickGuardar = async () => {

    try {
      if (cierreEnProceso) return; // si ya está ejecutando, no hace nada
      setCierreEnProceso(true);

      if (!cuit || !nombre || !apellido) {
        alert("Todos los campos son obligatorios.");
        return;
      }

      if (!esMenor) {
        if (!telefono || !eMail) {
          alert("E-Mail y Teléfono son obligatorios.");
          return;
        }
      }

      if (idCliente < 1) {
        const IdCliente = await function_ABM_EEX_Clientes_InsertarBasico(apellido, nombre,
          cuit, await FormateoFechaPara_yyyyMMdd(fechaNacimiento), cuit, eMail, telefono)

        const cuitTemporal = cuit

        setCUIT("")
        await AccionesSegunCUIT()

        setCUIT(cuitTemporal)
      }
      else {
        await function_ABM_EEX_Clientes_ModificarBasico(idCliente, apellido, nombre,
          cuit, await FormateoFechaPara_yyyyMMdd(fechaNacimiento), password, eMail, telefono)

        alert("Cliente modificado.")
      }
    } catch (error) {
      alert(error)
    } finally {
      setCierreEnProceso(false); // Se habilita el botón de nuevo
    }
  };

  if (modoDelControl === "VistaPersona") {
    return (
      <div className="LV-GroupBox-div"
        style={{
          alignItems: 'center',
          justifyContent: 'space-between'
        }}
      >
        <table style={{ width: '100%' }} >
          <tbody>
            <tr>
              <td style={{ width: '110px', margin: '2px', padding: '2px' }}>
                <NumberBox
                  value={cuit}
                  onValueChanged={handleCuitOnValueChanged}
                  label="D.N.I.">
                  <RequiredRule message="Indicar el D.N.I. es obligatorio." />
                </NumberBox>
              </td>

              <td style={{ width: '70px', margin: '2px', padding: '2px' }}>
                <NumberBox
                  value={idCliente}
                  readOnly={true}
                  onValueChanged={handleIdClienteOnValueChanged}
                  label="Código">
                </NumberBox>
              </td>
              <td style={{ margin: '0px', padding: '0px', width: '50px' }} >
                <LVButtonAccion Texto="🔍" Ancho={60} height={35} onClick={onClickBuscarCliente} />
              </td>
              {showPopupClientes ? (
                <>
                  {console.log('Se está mostrando el popup de clientes')}
                  <LVSelectorClientes
                    onSelectedCodigoChange={handleOnSelectedCodigoChange_Cliente}
                  />
                </>
              ) : null}
              <td style={{ margin: '2px', padding: '2px' }}>
                <TextBox
                  value={nombre}
                  onValueChanged={handleNombreOnValueChanged}
                  label="Nombre">
                  <RequiredRule message="Indicar el Nombre es obligatorio." />
                </TextBox>
              </td>

              <td style={{ margin: '2px', padding: '2px' }}>
                <TextBox
                  value={apellido}
                  onValueChanged={handleApellidoOnValueChanged}
                  label="Apellido">
                  <RequiredRule message="Indicar el Apellido es obligatorio." />
                </TextBox>
              </td>

              <td style={{ margin: '2px', padding: '2px' }}>
                <TextBox
                  value={telefono}
                  visible={!esMenor}
                  onValueChanged={handleTelefonoOnValueChanged}
                  label="Teléfono">
                  <RequiredRule message="Indicar el Teléfono es obligatorio." />
                </TextBox>
              </td>

              <td style={{ margin: '2px', padding: '2px' }}>
                <TextBox
                  value={eMail}
                  visible={!esMenor}
                  onValueChanged={handleEMailOnValueChanged}
                  label="E-Mail" >
                  <RequiredRule message="Indicar el E-Mail es obligatorio." />
                </TextBox>
              </td>

              <td style={{ width: '100px', margin: '2px', padding: '2px' }} rowSpan={2}>
                <LVButtonAccion
                  Disabled={cierreEnProceso} Texto={puedeGuardar ? "GUARDAR" : "MODIFICAR"} Ancho={'100%'} height={'75'} onClick={onClickGuardar} />
              </td>
            </tr>

            <tr>

              <td style={{ margin: '2px', padding: '2px' }}>
                <DateBox displayFormat="dd/MM/yyyy"
                  value={fechaNacimiento}
                  onValueChanged={handleFechaNacimientoOnValueChanged}
                  width={120}
                  label="F.Nacimiento" >
                </DateBox>
              </td>

              <td style={{ margin: '2px', padding: '2px' }} colSpan={6}>
                {mostrarSelectorLocacion && locaciones.length > 1 ? (
                  <div className="LV-GroupBox-div LV-FlexContainer">
                    <ComboAbmEexClientesLocaciones
                      IdCliente={idCliente}
                      onValueChanged={(e) => {
                        if (e.value && e.value !== "") {
                          const loc = locaciones.find(
                            (l) => l.CodigoLocacionCliente === e.value
                          );
                          if (loc) {
                            setCodigoLocacion(loc.CodigoLocacionCliente);
                            setTelefono(loc.TelefonoCelular || "");
                            setEMail(loc.Email || "");
                            setCalle(loc.Calle || "");
                            setNumero(loc.Numero || "");
                            setPiso(loc.Piso || "");
                            setDepto(loc.Depto || "");
                            setCodigoPostal(loc.CodigoPostal || "");
                          }
                          setMostrarSelectorLocacion(false);
                        } else {
                          setMostrarSelectorLocacion(true);
                        }
                      }}
                      value={codigoLocacion}
                      ancho={550}
                    />
                  </div>
                ) : (
                  !mostrarSelectorLocacion && (
                    <div className="LV-GroupBox-div LV-FlexContainer">
                      <TextBox
                        value={calle}
                        onValueChanged={handleCalleOnValueChanged}
                        width={"90%"}
                        label="Calle"
                        readOnly={true}
                      />
                      <NumberBox
                        value={numero}
                        onValueChanged={handleNumeroOnValueChanged}
                        label="Número"
                        readOnly={true}
                      />
                      <TextBox
                        value={piso}
                        onValueChanged={handlePisoOnValueChanged}
                        label="Piso"
                        readOnly={true}
                      />
                      <TextBox
                        value={depto}
                        onValueChanged={handleDeptoOnValueChanged}
                        label="Depto."
                        readOnly={true}
                      />
                      <span style={{ marginRight: "10px" }}>{" "}</span>
                      <TextBox
                        value={codigoPostal}
                        onValueChanged={handleCodigoPostalOnValueChanged}
                        label="C.Postal"
                        readOnly={true}
                      />

                      {locaciones.length > 1 && (
                        <LVButtonAccion
                          Texto="📍"
                          onClick={() => {
                            setCodigoLocacion("");
                            setMostrarSelectorLocacion(true);
                          }}
                        />
                      )}
                    </div>
                  )
                )}
              </td>

            </tr>
          </tbody>
        </table>
      </div >
    );
  } else if (modoDelControl === "VistaEmpresa") {
    return (
      <div className="LV-GroupBox-div"
        style={{
          alignItems: 'center',
          justifyContent: 'space-between'
        }}
      >
        <table style={{ width: '100%' }} >
          <tbody>
            <tr>
              <td style={{ width: '110px', margin: '2px', padding: '2px' }}>
                <NumberBox
                  value={cuit}
                  onValueChanged={handleCuitOnValueChanged}
                  label="C.U.I.T.">
                  <RequiredRule message="Indicar el C.U.I.T. es obligatorio." />
                </NumberBox>
              </td>

              <td style={{ width: '70px', margin: '2px', padding: '2px' }}>
                <NumberBox
                  value={idCliente}
                  readOnly={true}
                  onValueChanged={handleIdClienteOnValueChanged}
                  label="Código">
                </NumberBox>
              </td>

              <td style={{ margin: '2px', padding: '2px' }} >
                <TextBox
                  value={razonSocial}
                  onValueChanged={handleRazonSocialOnValueChanged}
                  label="Razón Social">
                  <RequiredRule message="Indicar la Razón Social es obligatorio." />
                </TextBox>
              </td>

              <td style={{ margin: '0px', padding: '0px', width: '50px' }} >
                <LVButtonAccion Texto="🔍" Ancho={60} height={35} onClick={onClickBuscarCliente} />
              </td>

              {showPopupClientes ? (
                <>
                  {console.log('Se está mostrando el popup de clientes')}
                  <LVSelectorClientes
                    onSelectedCodigoChange={handleOnSelectedCodigoChange_Cliente}
                  />
                </>
              ) : null}

              <td style={{ margin: '2px', padding: '2px' }}>
                <TextBox
                  value={telefono}
                  onValueChanged={handleTelefonoOnValueChanged}
                  label="Teléfono">
                  <RequiredRule message="Indicar el Teléfono es obligatorio." />
                </TextBox>
              </td>

              <td style={{ margin: '2px', padding: '2px' }}>
                <TextBox
                  value={eMail}
                  onValueChanged={handleEMailOnValueChanged}
                  label="E-Mail">
                  <RequiredRule message="Indicar el E-Mail es obligatorio." />
                </TextBox>
              </td>

              <td style={{ width: '100px', margin: '2px', padding: '2px' }} rowSpan={2}>
                <LVButtonAccion
                  Disabled={cierreEnProceso} Texto={puedeGuardar ? "GUARDAR" : "MODIFICAR"} Ancho={'100%'} height={'75'} onClick={onClickGuardar} />
              </td>
            </tr>

            <tr>

              <td style={{ margin: '2px', padding: '2px' }}>
                <DateBox displayFormat="dd/MM/yyyy"
                  value={fechaNacimiento}
                  onValueChanged={handleFechaNacimientoOnValueChanged}
                  width={120}
                  label="F.Inicio" >
                </DateBox>
              </td>

              <td style={{ margin: '2px', padding: '2px' }} colSpan={5}>
                {mostrarSelectorLocacion && locaciones.length > 1 ? (
                  <div className="LV-GroupBox-div LV-FlexContainer">
                    <ComboAbmEexClientesLocaciones
                      IdCliente={idCliente}
                      onValueChanged={(e) => {
                        if (e.value && e.value !== "") {
                          const loc = locaciones.find(
                            (l) => l.CodigoLocacionCliente === e.value
                          );
                          if (loc) {
                            setCodigoLocacion(loc.CodigoLocacionCliente);
                            setTelefono(loc.TelefonoCelular || "");
                            setEMail(loc.Email || "");
                            setCalle(loc.Calle || "");
                            setNumero(loc.Numero || "");
                            setPiso(loc.Piso || "");
                            setDepto(loc.Depto || "");
                            setCodigoPostal(loc.CodigoPostal || "");
                          }
                          setMostrarSelectorLocacion(false);
                        } else {
                          setMostrarSelectorLocacion(true);
                        }
                      }}
                      value={codigoLocacion}
                      ancho={550}
                    />
                  </div>
                ) : (
                  !mostrarSelectorLocacion && (
                    <div className="LV-GroupBox-div LV-FlexContainer">
                      <TextBox
                        value={calle}
                        onValueChanged={handleCalleOnValueChanged}
                        width={"90%"}
                        label="Calle"
                        readOnly={true}
                      />
                      <NumberBox
                        value={numero}
                        onValueChanged={handleNumeroOnValueChanged}
                        label="Número"
                        readOnly={true}
                      />
                      <TextBox
                        value={piso}
                        onValueChanged={handlePisoOnValueChanged}
                        label="Piso"
                        readOnly={true}
                      />
                      <TextBox
                        value={depto}
                        onValueChanged={handleDeptoOnValueChanged}
                        label="Depto."
                        readOnly={true}
                      />
                      <span style={{ marginRight: "10px" }}>{" "}</span>
                      <TextBox
                        value={codigoPostal}
                        onValueChanged={handleCodigoPostalOnValueChanged}
                        label="C.Postal"
                        readOnly={true}
                      />

                      {locaciones.length > 1 && (
                        <LVButtonAccion
                          Texto="📍"
                          onClick={() => {
                            setCodigoLocacion("");
                            setMostrarSelectorLocacion(true);
                          }}
                        />
                      )}
                    </div>
                  )
                )}
              </td>

            </tr>
          </tbody>
        </table>
      </div >
    );
  } else {
    return null;
  }
}

export default LV_EEX_Clientes;